import Translator from '../translator'
import React from 'react'
import { formatPrice } from '../../utils/format-price'
import { observer } from 'mobx-react-lite'
import clx from 'classnames'
import Settings from '../settings'
import { CartOverviewButton } from './cartOverviewButton'
import { CouponCodeField } from './couponCodeField'
import { RootStore } from '../../datastores/rootStore'

export const CartOverview = observer(function CartOverview({
  url,
  isLinkDisabled,
  validateStep,
  buttonText,
    buttonClasses = {},
  beforeNextButton = null,
  onClick = null,
  cart = RootStore.getInstance().cart,
  isOrder = false
}) {
  const text_boxes = Settings.getSetting('text_boxes', 'cart-overview')

  const [isSubmenuOpen, setIsSubmenuOpen] = React.useState(false)

  return (
    <div className='mtt-cart-overview'>
      <div className='mtt-cart-overview__content'>
        <h2 className='mtt-cart-title'>
          {Translator.translate('Oversigt', 'cart-overview')}
        </h2>

        <div className='mtt-cart-overview__price-line'>
          <div
            className={clx(
              'mtt-cart-overview__price-line-title',
              'has-submenu',
              { 'fw-medium': isSubmenuOpen, 'submenu-open': isSubmenuOpen }
            )}
            onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}
          >
            <div>
              {Translator.translate('Subtotal', 'cart-overview')}
              <div className='mtt-cart-overview__submenu-arrow'>
                {
                  <img
                    src={Settings.getSetting(
                      'icons/arrow-black.svg',
                      'cart-overview'
                    )}
                    alt=''
                  />
                }
              </div>
            </div>
            <div>{formatPrice(cart.cartSubTotal)}</div>
          </div>
          <div className='mtt-cart-overview__submenu'>
            {cart.eventGroups.map(eventGroup => (
              <div className='mtt-cart-overview__submenu-content' key={eventGroup.id}>
                <div className='mtt-cart-overview__price-line-title fw-medium small'>
                  <div>{eventGroup.title}</div>
                  <div className={'nowrap'}>{formatPrice(eventGroup.price)}</div>
                </div>
                {eventGroup.chosen_addons.map((addon) => {
                  return (
                      <div className='mtt-cart-overview__price-line-title small' key={addon.id}>
                        <div>{Translator.translate('Tilvalg:', 'cart-overview') + ' ' + addon.title}</div>
                        <div>{formatPrice(addon.totalPriceExDiscount)}</div>
                      </div>
                  )
                })}
              </div>
            ))}
          </div>
        </div>
        {cart.cartMailDiscount > 0 ? (
          <div className='mtt-cart-overview__price-line'>
            <div className='mtt-cart-overview__price-line-title'>
              <div>
                {Translator.translate('Maillisterabat', 'cart-overview')}
              </div>
              <div className='discount'>
                {formatPrice(cart.cartMailDiscount * -1)}
              </div>
            </div>
          </div>
        ) : null}
        {cart.cartLoyaltyDiscount > 0 ? (
          <div className='mtt-cart-overview__price-line'>
            <div className='mtt-cart-overview__price-line-title'>
              <div>
                {Translator.translate('Loyalitetsrabat', 'cart-overview')}
              </div>
              <div className='discount'>
                {formatPrice(cart.cartLoyaltyDiscount * -1)}
              </div>
            </div>
          </div>
        ) : null}
        {cart.cartCouponDiscount > 0 ? (
          <div className='mtt-cart-overview__price-line'>
            <div className='mtt-cart-overview__price-line-title'>
              <div>
                {cart.couponTitle ?? cart.coupon}
              </div>
              <div className='discount'>
                {formatPrice(cart.cartCouponDiscount * -1)}
              </div>
            </div>
          </div>
        ) : null}
        <div className='mtt-cart-overview__price-line'>
          <div
            className={clx('mtt-cart-overview__price-line-title', {
              'fw-medium': cart.customer.type !== 'private'
            })}
          >
            <div>
              {Translator.translate('Beløb (ekskl. moms)', 'cart-overview')}
            </div>
            <div>{formatPrice(cart.cartTotal)}</div>
          </div>
        </div>
        <div className='mtt-cart-overview__price-line'>
          <div
            className={clx('mtt-cart-overview__price-line-title', {
              'fw-medium': cart.customer.type === 'private'
            })}
          >
            <div>
              {Translator.translate(
                'Samlet beløb (inkl. moms)',
                'cart-overview'
              )}
            </div>
            <div>{formatPrice(cart.cartTotalWithVat)}</div>
          </div>
        </div>
        {!isOrder ? (
          <CouponCodeField />
        ) : null}

        {beforeNextButton}
        {buttonText != null ? (
          <CartOverviewButton
            url={url}
            onClick={onClick}
            isLinkDisabled={isLinkDisabled}
            validateStep={validateStep}
            buttonText={buttonText}
            buttonClasses={buttonClasses}
          />
        ) : null}

        {typeof text_boxes === 'object' && text_boxes.length > 0 ? (
          <div className={'mtt-cart-overview__text-boxes'}>
            {text_boxes.map((item, index) => {
              return (
                <div className='mtt-cart-overview__help' key={index}>
                  <h3>{item.title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.text
                    }}
                  />
                  {typeof item.buttons === 'object' &&
                  item.buttons.length > 0 ? (
                    <div className={'mtt-cart-overview__buttons'}>
                      {item.buttons.map((button, button_index) => {
                        return (
                          <a
                            href={button.button.url}
                            target={button.button.target}
                            key={button_index}
                          >
                            {button.button.title}
                          </a>
                        )
                      })}
                    </div>
                  ) : null}
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    </div>
  )
})
